var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',{staticClass:"inbox-sidebar-header"},[_vm._v("\n        "+_vm._s(_vm.section.title)+"\n    ")]),_vm._v(" "),_vm._l((_vm.section.entries),function(entry){return _c('received-files-sidebar-entry',{key:entry.name,attrs:{"entry":entry}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df2ce6a0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/received-files-view/received-files-sidebar-section.vue
// module id = 101
// module chunks = 0